export default __webpack_public_path__ + "static/tokens@2x-4e637586fa08364987b5e7cdf09fdc2c.png";